import {useEffect,useState} from 'react';

const uuid=/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
export function StaffMembershipPayment({location,customerId,productId,ticketKey,
  eligible,onComplete}:{location:string;customerId:string|null;
  productId:string|null;ticketKey:string;eligible:boolean;onComplete:()=>void}){
  const [busy,setBusy]=useState(false);
  const [enrollment,setEnrollment]=useState<string|null>(null);
  const [status,setStatus]=useState('');
  const [error,setError]=useState('');
  useEffect(()=>{
    setEnrollment(null);setStatus('');setError('');setBusy(false);
  },[ticketKey,customerId,productId,location]);
  useEffect(()=>{
    if(!enrollment||!customerId||status==='ACTIVE')return;
    let active=true;
    const poll=async()=>{
      try{
        const response=await fetch('/api/v1/staff/sales/stripe/test-membership/'+
          encodeURIComponent(enrollment)+'?'+new URLSearchParams({
            customerId,location,
          }),{credentials:'same-origin',cache:'no-store'});
        const body=await response.json() as {ok:boolean;data?:{
          status:string;paidInvoiceCount:number}};
        if(active&&response.ok&&body.ok&&body.data&&
          body.data.status==='ACTIVE'&&body.data.paidInvoiceCount>=1)
          setStatus('ACTIVE');
      }catch{/* No fabricated membership success on readback failure. */}
    };
    void poll();const interval=window.setInterval(()=>void poll(),3000);
    return ()=>{active=false;window.clearInterval(interval);};
  },[enrollment,customerId,location,status]);
  const checkout=async()=>{
    if(!eligible||!customerId||!productId||!uuid.test(productId)||busy)return;
    const tab=window.open('about:blank','_blank');
    setBusy(true);setError('');
    try{
      const response=await fetch('/api/v1/staff/sales/stripe/test-membership-checkout',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{'content-type':'application/json'},
        body:JSON.stringify({location,customerId,productId,idempotencyKey:ticketKey}),
      });
      const body=await response.json() as {ok:boolean;data?:{
        enrollmentId:string;checkoutUrl:string;status:string};error?:{code:string}};
      if(!response.ok||!body.ok||!body.data||
        body.data.status!=='UNPAID_TEST_SESSION'||
        !uuid.test(body.data.enrollmentId))
        throw Error(body.error?.code??'Membership Stripe TEST checkout unavailable.');
      const url=new URL(body.data.checkoutUrl);
      if(url.protocol!=='https:'||url.hostname!=='checkout.stripe.com')
        throw Error('Invalid Stripe membership checkout destination.');
      setEnrollment(body.data.enrollmentId);setStatus('PENDING');
      if(tab)tab.location.replace(url.href);
      else window.location.assign(url.href);
    }catch(e){tab?.close();setError(e instanceof Error?e.message:
      'Membership Stripe TEST checkout unavailable.');
    }finally{setBusy(false);}
  };
  return <div className="ecfs-membership-tender">
    <button type="button" disabled={!eligible||busy||status==='ACTIVE'}
      onClick={()=>void checkout()}>
      {busy?'Opening Card Checkout…':'Store Card'}</button>
    {enrollment&&<section className="ecfs-cash-tender"
      aria-label="Membership payment status">
      <p role="status">{status==='ACTIVE'
        ?'Membership first invoice verified; credits issued.'
        :'Membership checkout opened. Awaiting verified Stripe TEST invoice.'}</p>
      <small>Enrollment: {enrollment}</small>
      {status==='ACTIVE'&&<button type="button" onClick={onComplete}>
        Close Paid Sale</button>}
    </section>}
    {error&&<small role="alert">{error}</small>}
  </div>;
}
